<template>
  <div>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-form ref="form" @submit.prevent="handleSubmit">
          <v-card-title>
            {{
              mode === "create"
                ? __("Cadastrar categoria")
                : __("Alterar categoria")
            }}
            <v-spacer />
            <v-btn icon @click="closeDialog" :disabled="loading">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-text-field
              v-model="form.name"
              :label="__('Nome da categoria')"
              required
              clearable
              :disabled="loading"
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="closeDialog"
              :disabled="loading"
            >
              {{ __("cancelar") }}
            </v-btn>
            <v-btn
              type="submit"
              color="primary"
              :disabled="!form.name || loading"
              :loading="loading"
            >
              {{ __("confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/mixins/i18n";
import ToastsMixin from "@/mixins/ToastsMixin";

export default {
  mixins: [i18n, ToastsMixin],

  data() {
    return {
      i18n_prefix: "settings",
      dialog: false,
      form: { id: null, name: "" },
      mode: "create",
      loading: false,
    };
  },

  methods: {
    open(category = null) {
      if (category) {
        this.mode = "edit";
        this.form = { ...category };
      } else {
        this.mode = "create";
        this.form = { id: null, name: "" };
      }
      this.dialog = true;
    },

    closeDialog() {
      if (!this.loading) this.dialog = false;
    },

    async handleSubmit() {
      if (!this.form.name) return;

      this.loading = true;
      try {
        if (this.mode === "create") {
          await this.$emit("add", { ...this.form });
        } else {
          await this.$emit("update", { ...this.form });
        }
        this.dialog = false;
      } catch (e) {
        const message =
          e?.response?.data?.message ||
          this.__("Erro desconhecido ao processar a solicitação", "settings");

        this.toastError(message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
